import ProjectAPIError from "@/api/error/ProjectAPIError";

export default class ProjectAPIInternalServerError extends ProjectAPIError {
  get httpErrorMessage() {
    return "에러가 발생하였습니다(Internal Server Error)";
  }
}
